const SAFE_SECOND_CHAR = /^[a-zA-Z0-9_?#-]$/;
const LEADING_WHITESPACE_OR_CTRL = /^[\s\x00-\x1f\x7f]/;
const SCHEME_LIKE = /^[a-z][a-z0-9+.-]*:/i;
const ENCODED_SLASH_IN_PATH = /%2f|%5c/i;

export function isSafeReturnTo(value: unknown): value is string {
  if (typeof value !== 'string') return false;
  if (value.length === 0) return false;
  if (LEADING_WHITESPACE_OR_CTRL.test(value)) return false;
  if (SCHEME_LIKE.test(value)) return false;
  if (!value.startsWith('/')) return false;
  if (value.length === 1) return true;
  const second = value[1]!;
  if (second === '/' || second === '\\') return false;
  if (!SAFE_SECOND_CHAR.test(second)) return false;
  // Encoded slashes are only dangerous in the path. Allow them in
  // query / fragment.
  const queryStart = value.search(/[?#]/);
  const pathOnly = queryStart === -1 ? value : value.slice(0, queryStart);
  if (ENCODED_SLASH_IN_PATH.test(pathOnly)) return false;
  return true;
}

export function sanitizeReturnTo(value: unknown): string {
  return isSafeReturnTo(value) ? value : '/';
}
